import React from 'react'
import TextField from 'components/fields/TextField'
import { Field } from 'redux-form'
import IconButton from 'material-ui/IconButton'
import AddIcon from 'material-ui-icons/Add'
import DeleteIcon from 'material-ui-icons/Delete'
import { withStyles } from 'material-ui/styles'

const styles = theme => ({})

class Hashes extends React.Component {
  componentWillMount() {
    const { fields } = this.props
    if (fields.length === 0) {
      fields.push()
    }
  }

  render() {
    const { classes, fields } = this.props
    return (
      <div className={classes.root}>
        {fields.map((hash, index) => (
          <div key={index}>
            <Field name={hash} component={TextField} label="Public Address" />
            {fields.length > 1 && (
              <IconButton
                aria-label="Delete"
                onClick={() => fields.remove(index)}
              >
                <DeleteIcon />
              </IconButton>
            )}
            {index === fields.length - 1 && (
              <IconButton
                aria-label="Add"
                color="primary"
                onClick={() => fields.push()}
              >
                <AddIcon />
              </IconButton>
            )}
          </div>
        ))}
      </div>
    )
  }
}

export default withStyles(styles)(Hashes)



// WEBPACK FOOTER //
// ./src/components/fields/HashesArray.js